export default function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8" data-testid={testId}>
      <div>
        <h1 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900">{title}</h1>
        {subtitle && <p className="text-slate-500 mt-1.5">{subtitle}</p>}
      </div>
      {actions && <div className="flex gap-2">{actions}</div>}
    </div>
  );
}
